export default __webpack_public_path__ + "static/media/amrak.06920a93.png";